import Uri from 'urijs';

import type Localiser from '../core/modules/Localiser';
import type { Deal } from '../core/types/Deal';
import type { BuyingGuideBlockData } from '../core/types/HawkJSON';
import { ApiProductType } from '../types/ProductTypes';

/**
 * Creates a Deal object from a tabletop block with editorial data
 */
export const getDealFromEditorialData = ({
  block,
  index,
  localiser,
}: {
  block: BuyingGuideBlockData;
  index: number;
  localiser: Localiser;
}): Deal => {
  const link = block.link?.url ?? '';
  const linkText = block.link?.linkText ?? '';
  const merchantName = block.link?.merchantName || (link ? new Uri(link).domain() : 'merchant');
  const modelName = block.modelName ?? block.productName ?? '';

  return {
    an: block.link?.merchantNetwork,
    bundle_models: [],
    click_count: 0,
    click_count_weekly: 0,
    click_count_monthly: 0,
    image: block.imageUrl ?? null,
    label_image: null,
    last_update: null,
    model_id: 0,
    percentage: 0,
    popularity: 0,
    product_key: '',
    score: 0,
    shipping: {
      prime: false,
      url: null,
    },
    id: -(index + 1), // Negative IDs for editorial deals to avoid collision with API deals
    match_id: 0,
    product_type: ApiProductType.fallback,
    offer: {
      audience: null,
      link,
      name: modelName,
      link_text: linkText,
      merchant_link_text: linkText,
      label: localiser.translate('offerLabelNoPrice'),
      price: '',
      in_stock: true,
      stock_quantity: null,
      currency_iso: '',
      currency_symbol: '',
      percentage_saving: null,
      percentage_saving_label: null,
      money_saving: null,
      money_saving_label: null,
      product_note: null,
      display_name: modelName,
      display_labels: '',
      display_primary_label: '',
      was_price: undefined,
    },
    merchant: {
      id: block.link?.merchantId ?? 0,
      name: merchantName,
      url: block.link?.url ?? '',
      logo_url: '',
      territory: '',
      preference: 0,
    },
    model: modelName,
    requested_model: modelName,
    model_matched: [modelName],
    model_image: block.imageUrl ?? null,
    tracking_pixel_url: block.link?.trackingPixelUrl,
    labels_formatted: undefined,
  };
};
